import { ComponentSettings, empty } from "../settings/settings";

const field = {};

const settings = {
  text: {
    title: {
      de: "Business Konfig",
      en: "Business Config",
      nl: "Business Config",
    },
    warehouseGroup: {
      de: "Warengruppe Definition",
      en: "Warehouse Group Definition",
      nl: "Warehouse Group Definition",
    },
    warehouseGroupDescription: {
      de: "Diese Seite zeigt alle Warengruppen Definition, einschließlich Warengruppe, Warengruppe Bezeichnung, Proaktive Kennzeichnung, Warengruppe Auswirkung, Erstellt am Timestamp und Aktualisiert am Timestamp.<br>Nur Benutzer mit der Rolle Business Manager können die Felder Warengruppe Auswirkung und Proaktive Kennzeichnung bearbeiten. Alle anderen Benutzer haben nur Lesezugriff.",
      en: "This page displays all Warehouse Group Definitions, including the Warehouse Group, Warehouse Group Description, Proactive Flag, Warehouse Impact, Created on Timestamp, and Updated on Timestamp.<br>Only users with the Business Manager role can edit the Warehouse Group Impact and Proactive Flag fields. All other users have view-only access.",
      nl: "This page displays all Warehouse Group Definitions, including the Warehouse Group, Warehouse Group Description, Proactive Flag, Warehouse Impact, Created on Timestamp, and Updated on Timestamp.<br>Only users with the Business Manager role can edit the Warehouse Group Impact and Proactive Flag fields. All other users have view-only access.",
    },
    processes: {
      de: "Prozess",
      en: "Processes",
      nl: "Processes",
    },
    warehousePartsUpdate: {
      de: "Lagerteile aktualisieren",
      en: "Warehouse Parts Update",
      nl: "Magazijnonderdelen bijwerken",
    },
    processesDescription: {
      de: "Auf dieser Seite kann der Prozess <b>Warengruppe Definition</b> ausgeführt werden. Dabei werden alle Teile im System auf Grundlage der aktuellen Informationen aus den Warengruppen Definionen aktualisiert. Der Prozess umfasst: <br>&bull; das Setzen des Proaktive-Flags, <br>&bull; das Speichern des Warengruppe Auswirkung-Werts im Teiledokument, <br>&bull; und die Neuberechnung des Risikos für jedes Teil durch die Kombination des aktualisierten Auswirkung mit dem Wahrscheinlichkeitsfaktor. <br>Der Warehouse-Auswirkung-Wert – abgerufen aus den Warengruppen Definitionen und im Teiledokument gespeichert – wird als Komponente zur Berechnung des Gesamtauswirkung des Teils verwendet. Der endgültige Risikowert ergibt sich dann aus diesem Auswirkung zusammen mit der Wahrscheinlichkeit. <br>Die Seite zeigt außerdem einen vollständigen Verlauf aller Prozessdurchläufe zur Nachverfolgbarkeit.",
      en: "From this page, you can run the <b>Warehouse Parts Update</b> process. This process updates all parts in the system based on the latest data from the warehouse definitions. The update includes: <br>&bull; setting the proactive flag, <br>&bull; storing the warehouse impact value on the part document, <br>&bull; and recalculating the risk for each part by combining the updated impact with the likelihood factor. <br>The warehouse impact value—retrieved from the warehouse definitions and saved on the part document—is used as a component in calculating the overall part impact. The final risk score is then derived from this impact together with the likelihood. <br>The page also provides a full history of previous update runs for traceability.",
      nl: "From this page, you can run the <b>Warehouse Parts Update</b> process. This process updates all parts in the system based on the latest data from the warehouse definitions. The update includes: <br>&bull; setting the proactive flag, <br>&bull; storing the warehouse impact value on the part document, <br>&bull; and recalculating the risk associated with each part using an updated evaluation model. <br>This model incorporates the warehouse impact value—retrieved from the warehouse definitions and saved on the part document—as a component of the overall part impact. The final risk is then calculated as a function of this impact and the associated likelihood. <br>The page also provides a full history of previous update runs for traceability.",
    },
    noHistoryAvailable: {
      de: "Noch keine Historie vorhanden",
      en: "No history available yet",
      nl: "Nog geen geschiedenis beschikbaar",
    },
  },
  url: {},
  field,
  list: {
    warehouseGroupColumns: empty,
    processesColumns: empty,
  },
  permission: {
    seeBusinessConfig: false,
    seeWarehouseGroupSection: false,
    seeProcessesSection: false,
  },
  additionalInfo: {},
};

export const businessConfig: ComponentSettings<typeof settings> = settings;
